export default "__VITE_ASSET__B1rLZRQC__"